import { useId } from 'react';

export const OnField = () => {
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M11.715 6.00253C11.715 2.88374 9.18674 0.355469 6.06796 0.355469C2.94917 0.355469 0.420898 2.88374 0.420898 6.00253C0.420898 9.12131 2.94917 11.6496 6.06796 11.6496C9.18674 11.6496 11.715 9.12131 11.715 6.00253Z"
          fill="var(--c-green-400)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.68262 11.7043V0.395508H6.45203V11.7043H5.68262Z"
          fill="#101010"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0.705882C3.07614 0.705882 0.705882 3.07614 0.705882 6C0.705882 8.92386 3.07614 11.2941 6 11.2941C8.92386 11.2941 11.2941 8.92386 11.2941 6C11.2941 3.07614 8.92386 0.705882 6 0.705882ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
          fill="var(--c-green-400)"
        />
        <path
          d="M8.59203 8.79798C10.1107 7.35888 10.1751 4.96117 8.73601 3.44255C7.2969 1.92392 4.89919 1.85946 3.38057 3.29857C1.86195 4.73767 1.79748 7.13538 3.23659 8.65401C4.67569 10.1726 7.07341 10.2371 8.59203 8.79798Z"
          fill="#101010"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.59991 3.5299C2.2091 4.84788 2.15006 7.0438 3.46805 8.43461C4.78603 9.82543 6.98195 9.88446 8.37276 8.56648C9.76358 7.24849 9.82261 5.05257 8.50462 3.66176C7.18664 2.27095 4.99072 2.21191 3.59991 3.5299ZM3.00521 8.87322C1.44499 7.22679 1.51487 4.62728 3.1613 3.06706C4.80774 1.50684 7.40724 1.57672 8.96746 3.22315C10.5277 4.86959 10.4578 7.46909 8.81137 9.02931C7.16494 10.5895 4.56543 10.5196 3.00521 8.87322Z"
          fill="var(--c-green-400)"
        />
        <path
          d="M8.1999 5.0283L7.39519 4.20947L5.37872 6.1883L4.58813 5.39771L3.77637 6.20947L5.35754 7.79065L5.36696 7.78124L5.38107 7.79536L8.1999 5.0283Z"
          fill="var(--c-green-400)"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
